/* eslint-disable react/prop-types */
import ComposedViewDetailComponent from "./composed-view-detail";
import * as announcementHelper from "@/common/announcement-helper";
import * as helper from "@/common/helper";

function ComposedViewDetail({ announcement }) {
  const {
    title,
    openingDate,
    reportingDate,
    closingDate,
    correlationExpire,
    promoting,
    regions,
    cities,
    beneficiary,
    maxContribution,
    outgoings,
    types,
    granted,
    notes,
    technicalPDF,
    interventions,
    facilitation,
    incentive,
    sector,
    detailImageInfo,
  } = announcement;

  const status = announcementHelper.getStatus({ announcement });

  const dateLabel = announcementHelper.getDataLabel(status);

  const date = announcementHelper.getDate(status, announcement);

  const openingDate_ = helper.millisToDate({
    millis: openingDate,
  });
  const reportingDate_ = helper.millisToDate({
    millis: reportingDate,
  });
  const closingDate_ = helper.millisToDate({
    millis: closingDate,
  });
  const correlationExpire_ = helper.millisToDate({
    millis: correlationExpire,
  });

  const handlePdfClick = () => {
    window.open(technicalPDF?.base64, "_blank", "noopener,noreferrer");
  };
  return (
    <ComposedViewDetailComponent
      title={title}
      status={status}
      image={
        detailImageInfo
          ? detailImageInfo.base64
          : announcementHelper.PLACEHOLDER
      }
      openingDate={openingDate_}
      reportingDate={reportingDate_}
      closingDate={closingDate_}
      correlationExpire={correlationExpire_}
      promoting={promoting}
      cities={announcementHelper.getGeographicalArea(cities, regions)}
      beneficiary={announcementHelper.listToString(beneficiary)}
      maxContribution={maxContribution}
      outgoings={announcementHelper.listToString(outgoings)}
      types={announcementHelper.listToString(types)}
      granted={granted}
      notes={notes}
      pdf={technicalPDF?.base64}
      onPdfClick={handlePdfClick}
      interventions={interventions}
      facilitation={facilitation}
      incentive={incentive}
      sector={sector}
      dateLabel={dateLabel}
      date={date}
    />
  );
}

export default ComposedViewDetail;
